import { render, staticRenderFns } from "./CampaignTemplate.vue?vue&type=template&id=07e27291"
import script from "./CampaignTemplate.vue?vue&type=script&lang=js"
export * from "./CampaignTemplate.vue?vue&type=script&lang=js"
import style0 from "./CampaignTemplate.vue?vue&type=style&index=0&id=07e27291&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports